import React from 'react';
import { Modal, Box, Typography, Button, List, ListItem, ListItemText } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  borderRadius: '12px',
};

export default function QuadrantDetailModal({ open, handleClose, performanceCategory, fitCategory, count }) {
  // Mock data for demonstration purposes
  const mockPeople = [
    { name: 'Juan Pérez', email: 'juan.perez@example.com' },
    { name: 'María López', email: 'maria.lopez@example.com' },
    { name: 'Carlos García', email: 'carlos.garcia@example.com' },
    { name: 'Ana Rodríguez', email: 'ana.rodriguez@example.com' },
    { name: 'Luis Fernández', email: 'luis.fernandez@example.com' },
  ];

  const peopleToShow = mockPeople.slice(0, count > mockPeople.length ? mockPeople.length : count);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ fontWeight: 'bold', mb: 2 }}>
          Detalle de Personas - Desempeño {performanceCategory} / Fit Cultural {fitCategory}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2, mb: 2 }}>
          Total de personas: {count}
        </Typography>
        {peopleToShow.length > 0 ? (
          <List dense>
            {peopleToShow.map((person, index) => (
              <ListItem key={index}>
                <ListItemText primary={person.name} secondary={person.email} />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography variant="body2" color="text.secondary">No hay personas en este cuadrante para mostrar en la mock data.</Typography>
        )}
        <Button onClick={handleClose} variant="contained" sx={{ mt: 3 }}>Cerrar</Button>
      </Box>
    </Modal>
  );
} 